import { render } from "./BaseModal.vue?vue&type=template&id=27ed13dc&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=27ed13dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ed13dc"]])

export default __exports__